module.exports = __webpack_public_path__ + "static/media/insuranceClaim2.5af295ca.png";